import { CrawlRequest } from '@aibees/elephant/feature/suggestion-search-bar/components/crawl-request';
import { useIsCrawlRequestFeatureEnabled } from '@aibees/elephant/hooks';
import { Icon } from '@aibees/shared/components';
import { useQueryStringState } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ServiceCardDialogProps as Props } from './types';

export const ServiceCardDialog = memo(
  ({ className, state, service }: Props) => {
    const { icon, searchComponent, popoverTitle, searchCategory, serviceType } =
      service;
    const isCrawlRequestFeatureEnabled = useIsCrawlRequestFeatureEnabled();
    const { removeAllParams } = useQueryStringState();

    const handleClose = () => {
      state.onFalse();
      removeAllParams();
    };

    return (
      <Styled.Wrapper
        open={state.value}
        onClose={handleClose}
        className={classnames('ServiceCardDialog', className)}
        sx={SX.root}
        fullWidth
        maxWidth="smplus"
        padding="normal"
      >
        <Styled.Container gap={1.5}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack direction="row" alignItems="center" gap={1}>
              <Box sx={SX.iconBox}>
                {icon && <Icon color="primary.500" name={icon} size={18} />}
              </Box>
              <Typography variant="body2" color="grey.700">
                {popoverTitle}
              </Typography>
            </Stack>
            <Icon name="close" size={24} sxx={SX.close} onClick={handleClose} />
          </Stack>
          {searchComponent}

          {isCrawlRequestFeatureEnabled && (
            <CrawlRequest
              onSubmit={handleClose}
              searchCategory={searchCategory}
              serviceType={serviceType}
            />
          )}
        </Styled.Container>
      </Styled.Wrapper>
    );
  }
);

ServiceCardDialog.displayName = 'ServiceCardDialog';
